// extracted by mini-css-extract-plugin
export default {"iconInfo":"ReadyToPrint_iconInfo__Tg19m","iconContainer":"ReadyToPrint_iconContainer__rkD3r"};